import { MutationTree } from 'vuex';
import { State } from '@/stores/environment/state';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setEnvironment = (state: State, environment: string) => {
        state.environment = environment;
    }
    public setVersion = (state: State, version: string) => {
        state.version = version;
    }
}
